module.exports = __webpack_public_path__ + "img/23.8adea1a0.png";